import { render, staticRenderFns } from "./NewAccessoryBin.vue?vue&type=template&id=33aac7cb&scoped=true"
import script from "./NewAccessoryBin.vue?vue&type=script&lang=js"
export * from "./NewAccessoryBin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aac7cb",
  null
  
)

export default component.exports